/* import __COLOCATED_TEMPLATE__ from './enable_lightning_web_security_settings.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */

import Component from '@glimmer/component';
import type SalesforceConfiguration from 'embercom/models/standalone/salesforce-configuration';

export interface Args {
  isComplete: boolean;
  isLoading: boolean;
  salesforceConfiguration?: SalesforceConfiguration;
  openSessionSettingsPage: () => void;
}

interface Signature {
  Args: Args;
  Element: HTMLElement;
}

export default class SalesforceCopilotEnableLightningWebSecuritySettings extends Component<Signature> {
  get securitySessionSettingsUrl() {
    return this.args.salesforceConfiguration?.buildLightningSetupUrl('SecuritySession/home');
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Standalone::Deploy::Salesforce::Copilot::EnableLightningWebSecuritySettings': typeof SalesforceCopilotEnableLightningWebSecuritySettings;
    'standalone/deploy/salesforce/copilot/enable_lightning_web_security_settings': typeof SalesforceCopilotEnableLightningWebSecuritySettings;
  }
}
